import React from 'react';
import { DealBasics, Stage, ValuationBasis } from './types';
import styles from './MemoBuilder.module.css';

const STAGES: Stage[] = ['Pre-seed', 'Seed', 'Series A', 'Series B'];

interface Props {
  deal: DealBasics;
  onChange: (deal: DealBasics) => void;
}

const DealForm: React.FC<Props> = ({ deal, onChange }) => {
  const set = <K extends keyof DealBasics>(key: K, value: DealBasics[K]) => onChange({ ...deal, [key]: value });

  return (
    <div className={styles.formGrid}>
      <label className={`${styles.field} ${styles.fullWidth}`}>
        Company name
        <input
          className={styles.input}
          value={deal.companyName}
          onChange={(e) => set('companyName', e.target.value)}
          placeholder="Acme Robotics"
        />
      </label>

      <label className={styles.field}>
        Stage
        <select className={styles.input} value={deal.stage} onChange={(e) => set('stage', e.target.value as Stage)}>
          {STAGES.map((stage) => (
            <option key={stage}>{stage}</option>
          ))}
        </select>
      </label>

      <label className={styles.field}>
        Round size
        <input
          className={styles.input}
          value={deal.roundSize}
          onChange={(e) => set('roundSize', e.target.value)}
          placeholder="$4M"
        />
      </label>

      <label className={styles.field}>
        Valuation
        <div className={styles.inputGroup}>
          <input
            className={styles.input}
            value={deal.valuation}
            onChange={(e) => set('valuation', e.target.value)}
            placeholder="$20M"
          />
          <select
            className={styles.input}
            value={deal.valuationBasis}
            onChange={(e) => set('valuationBasis', e.target.value as ValuationBasis)}
            aria-label="Valuation basis"
          >
            <option value="post-money">Post</option>
            <option value="pre-money">Pre</option>
          </select>
        </div>
      </label>

      <label className={styles.field}>
        Lead investor
        <input
          className={styles.input}
          value={deal.leadInvestor}
          onChange={(e) => set('leadInvestor', e.target.value)}
          placeholder="Origin Ventures"
        />
      </label>

      <label className={`${styles.field} ${styles.fullWidth}`}>
        Deal owner (partner)
        <input
          className={styles.input}
          value={deal.dealOwner}
          onChange={(e) => set('dealOwner', e.target.value)}
          placeholder="Partner name"
        />
      </label>
    </div>
  );
};

export default DealForm;
